(function () {
	const sectionTabs = () => {
		const tabsSections = document.querySelectorAll(".testimonials");

		tabsSections.forEach((tabSection) => {
			const tabs = tabSection.querySelectorAll("[data-tab-target]");
			const tabContents = tabSection.querySelectorAll("[data-tab-content]");
			const isAutoplay = tabSection.dataset.autoplay === "true";
			const autoplaySpeed = parseInt(tabSection.dataset.autoplaySpeed, 10) || 5000;

			let maxContentHeight = 0;
			let autoplayInterval;

			// --- 1️⃣ Measure and set consistent height ---
			tabContents.forEach((tabContent) => {
				const originalDisplay = tabContent.style.display;
				tabContent.style.display = "block";
				const tabItemInfoBlock = tabContent.querySelector(".testimonials__item-block");
				if (tabItemInfoBlock.clientHeight > maxContentHeight) {
					maxContentHeight = tabItemInfoBlock.clientHeight;
				}
				tabContent.style.display = originalDisplay;
			});

			tabContents.forEach((tabContent) => {
				const tabItemInfoBlock = tabContent.querySelector(".testimonials__item-block");
				tabItemInfoBlock.style.minHeight = maxContentHeight + "px";
			});

			// --- 2️⃣ Tab switching logic ---
			const activateTab = (index) => {
				tabs.forEach((t) => t.classList.remove("active"));
				tabContents.forEach((c) => c.classList.remove("active"));
				tabs[index].classList.add("active");
				tabContents[index].classList.add("active");
			};

			tabs.forEach((tab, index) => {
				tab.addEventListener("click", () => {
					activateTab(index);
					if (isAutoplay) {
						// restart autoplay after user click
						clearInterval(autoplayInterval);
						startAutoplay();
					}
				});
			});

			// --- 3️⃣ Autoplay setup ---
			const startAutoplay = () => {
				if (!isAutoplay || tabs.length <= 1) return;

				let currentIndex = [...tabs].findIndex((t) => t.classList.contains("active"));
				clearInterval(autoplayInterval);

				autoplayInterval = setInterval(() => {
					currentIndex = (currentIndex + 1) % tabs.length;
					activateTab(currentIndex);
				}, autoplaySpeed);
			};

			startAutoplay();
		});
	};

	// Initialize + reinitialize on Shopify section load
	document.addEventListener("DOMContentLoaded", function () {
		sectionTabs();
		document.addEventListener("shopify:section:load", function () {
			sectionTabs();
		});
	});
})();
